import type { ComponentDefinition, CustomElementEntry } from './types'
import { writeCustomElementsModule } from './customElementsJs/writeCustomElementsModule'

export class ElementDefinitionBuilder {
    private readonly definitions = new Map<string, CustomElementEntry>()

    hasElement(tag: string): boolean {
        return this.definitions.has(tag)
    }

    addElement(tag: string, definition: ComponentDefinition): void {
        if (!tag.trim()) {
            throw new Error('Tag cannot be empty or whitespace')
        }
        if (this.definitions.has(tag)) {
            throw new Error(`Cannot add element: tag '${tag}' is already registered`)
        }
        this.definitions.set(tag, { tag, definition })
    }

    build(): string {
        const entries: CustomElementEntry[] = Array.from(this.definitions.values())
        return writeCustomElementsModule(entries)
    }
}
